module.exports = __webpack_public_path__ + "img/image23.a1da9eae.jpg";